import React from "react";
import { CATALOG } from "@/actions/catalog";

export enum ImportSourceType {
  Mycorr = "Mycorr",
  /// Houses every saved connection (postgres, supabase, google_oauth).
  /// Google Sheets is a `google_oauth` row inside this list, not a
  /// separate source.
  Connections = "Connections",
  Upload = "Upload",
}

type ImportSourceConfig = {
  label: string;
  icon: React.ReactNode;
};

export const SOURCE_CONFIG: Record<ImportSourceType, ImportSourceConfig> = {
  [ImportSourceType.Mycorr]: {
    label: CATALOG.importMycorr.label,
    icon: <CATALOG.importMycorr.Icon className="w-5 h-5" />,
  },
  [ImportSourceType.Connections]: {
    label: CATALOG.importConnection.label,
    icon: <CATALOG.importConnection.Icon sx={{ fontSize: 20 }} />,
  },
  [ImportSourceType.Upload]: {
    label: CATALOG.importFile.label,
    icon: <CATALOG.importFile.Icon sx={{ fontSize: 20 }} />,
  },
};

export const ALL_SOURCES = Object.values(ImportSourceType);
